function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//

import debounce from '@form-create/utils/lib/debounce';
import is from '@form-create/utils/lib/type';
export default {
  name: 'Fetch',
  props: {
    value: [Object, String],
    to: String
  },
  computed: {
    formValue: function formValue() {
      var val = this.value;
      if (!val) return {};
      if (is.String(val)) {
        return {
          action: val
        };
      }
      if (!val._parse && val.parse) {
        return _objectSpread(_objectSpread({}, val), {}, {
          _parse: '' + val.parse
        });
      } else if (is.Function(val._parse)) {
        return _objectSpread(_objectSpread({}, val), {}, {
          _parse: '' + val._parse
        });
      }
      return val;
    }
  },
  data: function data() {
    var _this = this;
    return {
      api: {},
      fetch: {},
      option: {
        form: {
          labelPosition: 'right',
          size: 'mini',
          labelWidth: '90px'
        },
        submitBtn: false
      },
      rule: [{
        type: 'input',
        field: 'action',
        title: '接口: ',
        validate: [{
          required: true,
          message: '请数据接口'
        }]
      }, {
        type: 'select',
        field: 'method',
        title: '请求方式: ',
        value: 'GET',
        options: [{
          label: 'GET',
          value: 'GET'
        }, {
          label: 'POST',
          value: 'POST'
        }]
      }, {
        type: 'Struct',
        field: 'data',
        title: '附带数据: ',
        value: {},
        props: {
          defaultValue: {}
        }
      }, {
        type: 'Struct',
        field: 'headers',
        title: 'header信息: ',
        value: {},
        props: {
          defaultValue: {}
        }
      }, {
        type: 'input',
        field: '_parse',
        title: '解析函数',
        info: '解析接口数据，返回组件所需的数据结构',
        value: 'function (res){\n   return res.data;\n}',
        props: {
          type: 'textarea',
          rows: 8
        },
        validate: [{
          validator: function validator(_, v, cb) {
            if (!v) return cb();
            try {
              _this.parseFn(v);
            } catch (e) {
              return cb(false);
            }
            cb();
          },
          message: '请输入正确的解析函数'
        }]
      }]
    };
  },
  methods: {
    parseFn: function parseFn(v) {
      return eval("(function(){return ".concat(v, " })()"));
    },
    _input: function _input() {
      var _this2 = this;
      this.api.submit(function (formData) {
        formData.to = _this2.to || 'options';
        if (formData._parse) formData.parse = _this2.parseFn(formData._parse);
        _this2.$emit('input', formData);
      });
    },
    input: debounce(function () {
      this._input();
    }, 1500)
  },
  mounted: function mounted() {
    this._input();
  }
};